export enum CountryCodes {
  Russia = 'RU',
  Kazakhstan = 'KZ',
  Lithuania = 'LT',
  Latvia = 'LV',
  Estonia = 'EE',
  Moldova = 'MD',
  Armenia = 'AM',
  Belarus = 'BY',
  Tajikistan = 'TJ',
  Turkmenistan = 'TM',
  Azerbaijan = 'AZ',
  Georgia = 'GE',
  Kyrgyzstan = 'KG',
  Uzbekistan = 'UZ',
  Test = 'TEST',
}
